import {useTranslation} from "react-i18next";
import IconBool from "components/IconBool";
import labelsDefault from "./labelsDefault";
import {ProfilesDateModel} from "site-apps/authuser/ProfilesModel";
import OrderByHeaders from "components/ordering/OrderByHeaders";

/*
items={items}
itemsShown={itemsShown}
chosen={chosen}
buttonsTB={buttonsTB}
setItemsShown={setItemsShown}
setItem={setItem}
setButtonsTB={setButtonsTB}
 */
const TableUsers = ({itemsShow, items, checkAll, setCheckAll, buttonsTB, setButtonsTB, orderingRef}) => {
    const [t] = useTranslation("tables");

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "162px",
        backgroundColor: "white",
        zIndex: 799,
    };

    return (
        <table className="table-islands table table-striped sticky-horizontal">
            <thead>
                <tr>
                    <th
                        key="-1"
                        style={{
                            ...stickyHeaderStyle,
                        }}
                        className="sticky-top border-bottom-sticky">
                        <input className="form-check-input" type="checkbox" checked={checkAll} onChange={handleCheckAll} />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} />
                </tr>
            </thead>
            <tbody id="data-list">
                {itemsShow.map((item) => (
                    <tr key={item.id} data-idx={item.id} onClick={onClick}>
                        <td>
                            <input
                                type="checkbox"
                                name="checkboxContainer"
                                key={item.id}
                                data-idx={item.id}
                                defaultChecked={items.current.chosen.includes(item.id)}
                                readOnly={true}
                            />
                        </td>
                        <td>
                            <IconBool value={item.is_active} />
                        </td>
                        <td>{item.email}</td>
                        <td>{item.first_name + " " + item.last_name}</td>
                        <td>{item.orgs_names}</td>
                        <td>{item.panels_names}</td>
                        <td className="text-center">
                            <IconBool value={item.is_admin} />
                        </td>
                        <td className="text-center">
                            <IconBool value={item.is_tech} />
                        </td>
                        <td className="text-center">
                            <IconBool value={item.is_maint} />
                        </td>
                        <td className="text-center">
                            <IconBool value={item.dri_user} />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableUsers;
